<script>
    import { createEventDispatcher } from 'svelte';

    let search = (localStorage.getItem("search")) ? localStorage.getItem("search"): "";
    export let placeholder = "Search by Portco, Name, Email or Location";
    export let className = 'col-md-3';
    export let debounceTimeOut = 700;

    const dispatch = createEventDispatcher();

    let debounceTimer = null;

    let debounce = function(){
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            if (search === '') {
                search = null;
            }

            if (search === null) {
                localStorage.removeItem("search");
                dispatch('change', { search: search });
            } else {
                search = search.trim().toLowerCase();
                localStorage.setItem("search", search);
                dispatch('change', { search: search });
            }
        }, debounceTimeOut);
    }

    let checkClearClick = function() {
        search = '';
        debounce();
    }
</script>

<div class="{className}">
    <input class="form-control search-input" type="search" placeholder="{placeholder}"
            on:keyup={debounce} on:change={debounce} on:search={checkClearClick} bind:value={search}>
</div>
